export const columns = [
  {
    title: '소모품명',
    dataIndex: 'name',
    key: 'name',
    width: 100,
  },
];
